import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { WholesaleAuthProvider } from './contexts/WholesaleAuthContext';
import { CartProvider } from './contexts/CartContext';
import { WholesaleCartProvider } from './contexts/WholesaleCartContext';
// import Navbar from './components/Navbar/Navbar';
// import Footer from './components/Footer/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
// import ProductsPage from './pages/ProductsPage';
import WholesalePage from './pages/WholesalePage';
import WholesalePageRedesign from './pages/WholesalePageRedesign';
import ContactPage from './pages/ContactPage';
import BookingPage from './pages/BookingPage';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import AdminPanel from './components/Admin/AdminPanel';
import AdminMenuPage from './pages/AdminMenuPage';
import AdminMenuPageRedesign from './pages/AdminMenuPageRedesign';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import StaffProtectedRoute from './components/Auth/StaffProtectedRoute';
import RoasterProtectedRoute from './components/Auth/RoasterProtectedRoute';
import BaristaProtectedRoute from './components/Auth/BaristaProtectedRoute';
import ProductManagement from './components/Admin/ProductManagement';
import AvailableProducts from './components/Admin/AvailableProducts';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ShippingPolicy from './pages/ShippingPolicy';
import RefundPolicy from './pages/RefundPolicy';
import ContactInformation from './pages/ContactInformation';
import AdminLegalManagement from './pages/AdminLegalManagement';
import AdminHomePageEdit from './pages/AdminHomePageEdit';
import WaiterTab from './components/Admin/WaiterTab';
import CashierTab from './components/Admin/CashierTab';
import CustomerOrderPage from './pages/CustomerOrderPage';
import OrderStatusPage from './pages/OrderStatusPage';
import AdminSalesReportPage from './pages/AdminSalesReportPage';
import WeeklySalesReportPage from './pages/WeeklySalesReportPage';
import AdminLayout from './components/Admin/AdminLayout';
import MenuPageNew from './pages/MenuPageNew';
import ShopsPage from './pages/ShopsPage';
import ReceiptPage from './pages/ReceiptPage';
import AdminOrdersPage from './pages/AdminOrdersPage';
import OrderConfirmation from './pages/OrderConfirmation';
import DebugSkipCash from './pages/DebugSkipCash';
import PaymentRecovery from './pages/PaymentRecovery';
import SkipCashReturn from './pages/SkipCashReturn';
import OrderSuccessPage from './pages/OrderSuccessPage';
import TestRoasterNotification from './pages/TestRoasterNotification';
import AdminWholesalePage from './components/Admin/AdminWholesalePage';
import WholesaleInventory from './components/Admin/WholesaleInventory';
import WholesaleDashboard from './components/Wholesale/WholesaleDashboard';
import WholesaleLogin from './pages/WholesaleLogin';
import WholesaleApplication from './pages/WholesaleApplication';
import WholesaleProtectedRoute from './components/Auth/WholesaleProtectedRoute';
import MenuManagement from './components/Admin/MenuManagement';
import ProductTemplateManager from './components/Admin/ProductTemplateManager';
import ShopsManagement from './components/Admin/ShopsManagement';
import CatalogueManagement from './components/Admin/CatalogueManagement';
import WholesaleTestSetup from './pages/WholesaleTestSetup';
import WholesaleOrderSuccess from './pages/WholesaleOrderSuccess';
import WholesaleProductCatalog from './components/Wholesale/WholesaleProductCatalog';
import SmartWholesaleHandler from './components/SmartWholesaleHandler';
import WaitingListPage from './pages/WaitingListPage';
import AdminWaitingList from './components/Admin/AdminWaitingList';
import AdminSeatedList from './components/Admin/AdminSeatedList';
import UnderConstructionPage from './pages/UnderConstructionPage';
import DatabaseSearch from './pages/DatabaseSearch';
import WasteLog from './components/Admin/WasteLog';
import UserManagement from './components/Admin/UserManagement';
import LinksPage from './pages/LinksPage';
import AdminLinksPage from './pages/AdminLinksPage';
import AdminSettingsPage from './components/Admin/AdminSettingsPage';
import InventoryList from './pages/InventoryList';
import LowStockDashboard from './pages/LowStockDashboard';
import InventoryAuditPage from './pages/InventoryAuditPage';
import RoasterInventoryPage from './pages/RoasterInventoryPage';
import BaristaBeansRequestPage from './pages/BaristaBeansRequestPage';
import ContactMessages from './components/Admin/ContactMessages';
import CookieConsent from './components/CookieConsent';
import AnalyticsDashboard from './components/Admin/AnalyticsDashboard';
import LetterTemplateManager from './components/Admin/LetterTemplateManager';
import LetterGenerator from './components/Admin/LetterGenerator';
import GeneratedLettersList from './components/Admin/GeneratedLettersList';
import AdminAccountingPage from './pages/AdminAccountingPage';
import SimpleDebug from './components/Debug/SimpleDebug';
import TrackingTest from './components/Debug/TrackingTest';
import ButtonTest from './components/Test/ButtonTest';
import FirebaseDataCheck from './debug/FirebaseDataCheck';
import MobileBeanDetails from './pages/MobileBeanDetails';
import UnderConstruction from './pages/UnderConstruction';
import CataloguePage from './pages/CataloguePage';
import ProductDetailPage from './pages/ProductDetailPage';
import MenuRouter from './pages/MenuRouter';
import './services/firestoreCleanup'; // Initialize Firestore cleanup handlers
import './services/visitorTracking'; // Initialize visitor tracking


function App() {
  return (
    <Router>
      <AuthProvider>
        <WholesaleAuthProvider>
          <WholesaleCartProvider>
            <CartProvider>
            <div className="App">
              {/* <Navbar /> */}
              <main>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/links" element={<LinksPage />} />

                  {/* Under Construction Routes */}
                  <Route path="/products" element={<UnderConstructionPage />} />
                  <Route path="/catalogue" element={<CataloguePage />} />
                  <Route path="/product/:id" element={<ProductDetailPage />} />
                  <Route path="/bean/:id" element={<MobileBeanDetails />} />
                  <Route path="/wholesale" element={<WholesalePageRedesign />} />

                  {/* <Route path="/products" element={<ProductsPage />} /> */}
                  <Route path="/wholesale-smart" element={<SmartWholesaleHandler />} />
                  <Route path="/wholesale/:id" element={
                    <WholesaleProtectedRoute>
                      <WholesaleDashboard />
                    </WholesaleProtectedRoute>
                  } />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/booking" element={<BookingPage />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/cart" element={<CartPage />} />
                  <Route path="/checkout" element={<CheckoutPage />} />
                  <Route path="/order-confirmation" element={<OrderConfirmation />} />
                  <Route path="/order-success" element={<OrderSuccessPage />} />
                  <Route path="/test-roaster-notification" element={<TestRoasterNotification />} />
                  <Route path="/debug-skipcash" element={<DebugSkipCash />} />
                  <Route path="/payment-recovery" element={<PaymentRecovery />} />
                  <Route path="/receipt/:orderId" element={<ReceiptPage />} />
                  <Route path="/terms-of-service" element={<TermsOfService />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/shipping-policy" element={<ShippingPolicy />} />
                  <Route path="/refund-policy" element={<RefundPolicy />} />
                  <Route path="/contact-information" element={<ContactInformation />} />
                  <Route path="/customer-order" element={<CustomerOrderPage />} />
                  <Route path="/order-status" element={<OrderStatusPage />} />
                  <Route path="/menu" element={<MenuPageNew />} />
                  <Route path="/menu/:branch" element={<MenuPageNew />} />
                  <Route path="/debug" element={<SimpleDebug />} />
                  <Route path="/tracking-test" element={<TrackingTest />} />
                  <Route path="/test-button" element={<ButtonTest />} />
                  <Route path="/firebase-data" element={<FirebaseDataCheck />} />
                  <Route path="/admin" element={<ProtectedRoute requireAdmin><AdminLayout /></ProtectedRoute>}>
                    <Route index element={<AdminPanel />} />
                    <Route path="menu" element={<AdminMenuPageRedesign />} />
                    <Route path="shops" element={<ShopsManagement />} />
                    <Route path="product-template" element={<ProductTemplateManager />} />
                    <Route path="products" element={<ProductManagement />} />
                    <Route path="catalogue" element={<CatalogueManagement />} />
                    <Route path="available-products" element={<AvailableProducts />} />
                    <Route path="legal" element={<AdminLegalManagement />} />
                    <Route path="homepage" element={<AdminHomePageEdit />} />
                    <Route path="waiter" element={<WaiterTab />} />
                    <Route path="cashier" element={<CashierTab />} />
                    <Route path="sales" element={<AdminSalesReportPage />} />
                    <Route path="salesreport" element={<AdminSalesReportPage />} />
                    <Route path="weekly-sales" element={<WeeklySalesReportPage />} />
                    <Route path="weekly-sales-report" element={<WeeklySalesReportPage />} />
                    <Route path="wholesale" element={<AdminWholesalePage />} />
                    <Route path="wholesale-inventory" element={<WholesaleInventory />} />
                    <Route path="orders" element={<AdminOrdersPage />} />
                    <Route path="waiting-list" element={<AdminWaitingList />} />
                    <Route path="seated-list" element={<AdminSeatedList />} />
                    <Route path="database-search" element={<DatabaseSearch />} />
                    <Route path="users" element={<UserManagement />} />
                    <Route path="links" element={<AdminLinksPage />} />
                    <Route path="settings" element={<AdminSettingsPage />} />
                    <Route path="low-stock" element={<LowStockDashboard />} />
                    <Route path="inventory-audit" element={<InventoryAuditPage />} />
                    <Route path="contact-messages" element={<ContactMessages />} />
                    <Route path="analytics" element={<AnalyticsDashboard />} />
                    <Route path="letter-templates" element={<LetterTemplateManager />} />
                    <Route path="generate-letter" element={<LetterGenerator />} />
                    <Route path="generated-letters" element={<GeneratedLettersList />} />
                    <Route path="accounting" element={<AdminAccountingPage />} />
                  </Route>
                  <Route path="/skipcash-return" element={<SkipCashReturn />} />
                  <Route path="/wholesale-test-setup" element={<WholesaleTestSetup />} />
                  <Route path="/wholesale-login" element={<WholesaleLogin />} />
                  <Route path="/wholesale-application" element={<WholesaleApplication />} />
                  <Route path="/wholesale-dashboard" element={
                    <WholesaleProtectedRoute>
                      <Navigate to="/wholesale-dashboard/overview" replace />
                    </WholesaleProtectedRoute>
                  } />
                  <Route path="/wholesale-dashboard/overview" element={
                    <WholesaleProtectedRoute>
                      <WholesaleDashboard />
                    </WholesaleProtectedRoute>
                  } />
                  <Route path="/wholesale-dashboard/catalog" element={
                    <WholesaleProtectedRoute>
                      <WholesaleDashboard />
                    </WholesaleProtectedRoute>
                  } />
                  <Route path="/wholesale-dashboard/orders" element={
                    <WholesaleProtectedRoute>
                      <WholesaleDashboard />
                    </WholesaleProtectedRoute>
                  } />
                  <Route path="/wholesale-dashboard/checkout" element={
                    <WholesaleProtectedRoute>
                      <WholesaleDashboard />
                    </WholesaleProtectedRoute>
                  } />
                  <Route path="/wholesale-dashboard/invoices" element={
                    <WholesaleProtectedRoute>
                      <WholesaleDashboard />
                    </WholesaleProtectedRoute>
                  } />
                  <Route path="/wholesale-dashboard/settings" element={
                    <WholesaleProtectedRoute>
                      <WholesaleDashboard />
                    </WholesaleProtectedRoute>
                  } />
                  <Route path="/wholesale/dashboard" element={
                    <WholesaleProtectedRoute>
                      <WholesaleDashboard />
                    </WholesaleProtectedRoute>
                  } />
                  <Route path="/wholesale/catalog" element={
                    <WholesaleProtectedRoute>
                      <WholesaleProductCatalog />
                    </WholesaleProtectedRoute>
                  } />
                  <Route path="/wholesale-order-success" element={<WholesaleOrderSuccess />} />
                  <Route path="/waiting-list" element={<WaitingListPage />} />
                  <Route path="/inventory" element={<InventoryList />} />
                  <Route path="/roaster/inventory" element={
                    <RoasterProtectedRoute>
                      <RoasterInventoryPage />
                    </RoasterProtectedRoute>
                  } />
                  <Route path="/barista/beans-request" element={
                    <BaristaProtectedRoute>
                      <BaristaBeansRequestPage />
                    </BaristaProtectedRoute>
                  } />
                </Routes>
              </main>
              {/* <Footer /> */}
              <CookieConsent />
            </div>
            </CartProvider>
          </WholesaleCartProvider>
        </WholesaleAuthProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;